export const visibleScrollbar = (scrollbarClass: string) => {
  const webkitStyles = `
    [&::-webkit-scrollbar-track]:bg-transparent 
    [&::-webkit-scrollbar-track]:rounded-full 
    dark:[&::-webkit-scrollbar-track]:bg-transparent 
    [&::-webkit-scrollbar-thumb]:bg-[rgba(120,120,120,0.28)] 
    [&::-webkit-scrollbar-thumb]:rounded-full 
    dark:[&::-webkit-scrollbar-thumb]:bg-[rgba(245,245,245,0.22)]
  `
    .replace(/\s+/g, " ")
    .trim();

  // Add Firefox fallback using scrollbar-width and scrollbar-color
  const firefoxStyles = `
    scrollbar-width-thin 
    scrollbar-color-[rgba(120,120,120,0.28)] 
    dark:scrollbar-color-[rgba(245,245,245,0.22)]
  `;

  return `${webkitStyles} ${firefoxStyles} ${scrollbarClass}`;
};
